import Raven from 'raven';
import { request, Error as _Error } from './request';
import { Performance } from './Performance';
import { getEnv } from './utils';

const env = getEnv();
const Error = {
    EVENT: 'web_sourcemap_error',
    GLOBAL: 'sourcemap_global'
};
let inited = false;
//手动上报
function reportException(e, api) {
    if (inited) {
        Raven.captureException(e);
    } else {
        Performance.log({
            type: 'error',
            label: _Error.USERERROR,
            event: api ? _Error.EVENT : Error.EVENT,
            extra: {
                api: api || '',
                content: JSON.stringify(e, ['name', 'stack'])
            }
        });
    }
}

function sendRequest(res, msg) {
    const dataArray = [];
    res.data.forEach(element => {
        const ele = {
            fileName: element.source,
            codeArray: []
        };
        if (element.sourcesContent) {
            const lines = element.sourcesContent.split('\n');
            const start = element.line > 5 ? element.line - 5 : element.line;
            const data = lines.slice(start, element.line + 5);
            data.forEach((e, i) => {
                let line = {
                    line: start + i + 1,
                    messgage: e,
                    heightlight: i + 1 === 5
                };
                ele.codeArray.push(line);
            });
            dataArray.push(ele);
        }
    });
    //上报
    Performance.log({
        type: 'error',
        label: Error.GLOBAL,
        event: Error.EVENT,
        extra: {
            msg: msg || '',
            content: dataArray
        }
    });
}

async function sendMonitor(data) {
    request({
        url: '/webkara/monitor',
        json: true,
        method: 'post',
        error: () => {},
        log: false,
        data: data,
        callback: res => {
            if (res.err_code != 0) return;
            sendRequest(res, data.msg);
        }
    });
}

function init() {
    const _ravenConfig = {
        release: 'monitor@1.0.0'
    };
    const raven = Raven.config('https://www.pokekara.com/', _ravenConfig);
    raven.install();
    raven.setTransport(function(option) {
        const _data = {
            stack: option.data,
            msg: (() => {
                const res = [];
                const data = option.data;
                data.exception &&
                    data.exception.values &&
                    data.exception.values.length &&
                    res.push(`${data.exception.values[0].type}:${data.exception.values[0].value}`);
                return res.join(';');
            })()
        };
        sendMonitor(_data);
        option.onSuccess();
    });
    inited = true;
}

function formatComponentName(vm) {
    if (vm.$root === vm) {
        return 'root instance';
    }
    const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
    return (
        (name ? 'component <' + name + '>' : 'anonymous component') +
        (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
    );
}

function inJectMonitor(Vue) {
    if (env === 'cdn') {
        init();
        /*
        const _oldOnError = Vue.config.errorHandler;
        Vue.config.errorHandler = function(error, vm, info) {
            const metaData = {};
            if (Object.prototype.toString.call(vm) === '[object Object]') {
                metaData.componentName = formatComponentName(vm);
                metaData.propsData = vm.$options.propsData;
            }
            if (typeof info !== 'undefined') {
                metaData.lifecycleHook = info;
            }
            Raven.captureException(error, {
                extra: metaData
            });
            if (typeof _oldOnError === 'function') {
                _oldOnError.call(this, error, vm, info);
            }
        };
        */
    }
}

export { inJectMonitor, reportException };
